import { POST, GET } from '@sisyphe/utils'

/**
 * @description 账号信息查询
 */
export function queryAccountUsingPOST_1(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/account/query',
    params
  )
}

/**
 * @description 用户地址新增
 */
export function addressAddUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/address/add',
    params
  )
}

/**
 * @description 用户地址删除
 */
export function addressDelUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/address/del',
    params
  )
}

/**
 * @description 用户地址编辑
 */
export function addressEditUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/address/edit',
    params
  )
}

/**
 * @description 商品分类配置回显
 */
export function echoProductConfigUsingPOST_1({
  enterpriseCode,
  ...params
}: {
  enterpriseCode: string
}): Promise<{ data: Array<SwaggerDTO.ProductConfigSpuInfoDTO> }> {
  return POST(
    `/enterprise-procurement-client/enterprise/store/echo?enterpriseCode=${enterpriseCode}`,
    params
  )
}

/**
 * @description 订单-确认收货
 */
export function ensureOrderUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/ensure/order',
    params
  )
}

/**
 * @description 商城首页查询-App
 */
export function homepageQueryUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.商城首页列表数据Req>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/home/query',
    params
  )
}

/**
 * @description 商城首页查询-查看更多
 */
export function morePageQueryUsingPOST(
  params: SwaggerDTO.商城商品分类查询
): Promise<SwaggerDTO.PageResult<SwaggerDTO.商城首页列表商品>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/home/query/more',
    params
  )
}

/**
 * @description 商城商品详情查询-App
 */
export function queryDetailQueryUsingPOST(
  params: SwaggerDTO.商品详情查询
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.GoodsMainInfoDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/home/queryDetail/other',
    params
  )
}

/**
 * @description 商城搜索框搜索
 */
export function searchUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.搜索响应Res[]>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/input/queryDetail/other',
    params
  )
}

/**
 * @description 库存校验
 */
export function judgeCacheUsingPOST(
  params: SwaggerDTO.库存校验参数
): Promise<{ data: Array<SwaggerDTO.CacheBookStockResDTO> }> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/judge/cache',
    params
  )
}

/**
 * @description 订单列表查询
 */
export function queryOrderListUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/order/query',
    params
  )
}

/**
 * @description 订单详情查询
 */
export function queryOrderDetailUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/order/queryDetail',
    params
  )
}

/**
 * @description 订单-再来一单
 */
export function orderRepeatUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/order/repeat',
    params
  )
}

/**
 * @description 购物车管理-新增商品
 */
export function shopCarAddUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCarAdd',
    params
  )
}

/**
 * @description 购物车管理-删除商品
 */
export function shopCarDelUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCarDel',
    params
  )
}

/**
 * @description 购物车管理-数量编辑
 */
export function shopCarEditUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.BaseResponseDTO>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCarEdit',
    params
  )
}

/**
 * @description 商城搜索框搜索-banner信息查询
 */
export function queryBannerUsingPOST_1(
  params: SwaggerDTO.banner查询请求参数
): Promise<SwaggerDTO.PageResult<SwaggerDTO.banner基础信息>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/banner/query',
    params
  )
}

/**
 * @description 购物车管理-添加购物车
 */
export function shopCartAddUsingPOST(
  params: SwaggerDTO.新增购物车请求参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCart/add',
    params
  )
}

/**
 * @description 购物车管理-选中
 */
export function chooseCartUsingPOST(
  params: SwaggerDTO.购物车商品选中请求参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCart/choose',
    params
  )
}

/**
 * @description 购物车管理-删除商品
 */
export function shopCartDelUsingPOST(
  id?: string | number
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    `/enterprise-procurement-client/enterprise/store/shopCart/del/${id}`
  )
}

/**
 * @description 购物车管理-数量编辑
 */
export function shopCartEditUsingPOST(
  params: SwaggerDTO.购物车数量编辑请求参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCart/edit',
    params
  )
}

export namespace SwaggerDTO1 {
  export interface 购物车信息1 extends SwaggerDTO.购物车信息1 {
    /**缺货状态 */
    stockStatus?: boolean
    /**下架状态 */
    shelfStatus?: boolean
  }
  export interface 购物车响应信息
    extends Omit<SwaggerDTO.购物车响应信息, 'cartInfoDTOS'> {
    cartInfoDTOS?: Array<购物车信息1>
  }
}

/**
 * @description 购物车管理-购物车列表
 */
export function shopCartListUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO1.购物车响应信息>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCart/list',
    params
  )
}

/**
 * @description 购物车管理-购物车数量
 */
export function shopCartNumUsingPOST(
  params?: any
): Promise<SwaggerDTO.ResponseResult<number>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCart/num',
    params
  )
}

/**
 * @description 购物车管理-提交订单
 */
export function placeOrderUsingPOST(
  params: SwaggerDTO.下单请求参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.下单成功后返回订单编号>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCart/place/order',
    params
  )
}

/**
 * @description 购物车管理-批量删除商品
 */
export function shopCartBatchDelUsingPOST({
  ids,
  ...params
}: {
  ids: Array<any>
}): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.XXFResponseResult>> {
  return POST(
    `/enterprise-procurement-client/enterprise/store/shopCart/batch/del?ids=${ids}`,
    params
  )
}

/**
 * @description 购物车管理-结算接口
 */
export function checkOrderUsingPOST(
  params: SwaggerDTO.下单请求参数
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.订单结算校验响应实体类>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/shopCart/check/order',
    params
  )
}

/**
 * @description 购物车管理-再来一单
 */
export function repeatUsingGET(
  orderNo
): Promise<SwaggerDTO.ResponseResult<SwaggerDTO.订单结算校验响应实体类>> {
  return GET(
    `/enterprise-procurement-client/enterprise/store/repeat/${orderNo}`
  )
}
